<template>
  <q-page style="height: 100vh">
    <q-img
      class="bg-accent"
      style="height: 100vh; position: absolute; width: 100vw"
      :src="`/statics/loginBackgrounds/${backgroundImage}.jpg`"
    >
    </q-img>
    <div
      class="slsLogo"
      :class="{
        slsLogoMobile: $q.screen.lt.sm,
      }"
    >
      <q-img src="/statics/wavesBlueTextLogoTransparent.png"> </q-img>
    </div>

    <div class="row" align="center" justify="center">
      <div class="col">
        <q-card class="loginCard fixed-center">
          <q-card-section class="">
            <div class="row">
              <div class="col-12">
                <div style="max-width: 500px; max-height: 90%">
                  <!-- <q-img
                    src="/statics/Logo.png"
                    spinner-color="white"
                    :ratio="2 / 1"
                    contain
                  /> -->
                  <h3 class="loginHeader q-my-xs">Lifesaving Sport</h3>
                  <h6 class="q-my-none">EVENT MANAGEMENT SYSTEM</h6>
                  <p>Designed by Surf Life Saving New Zealand (C)</p>
                </div>
              </div>
            </div>
          </q-card-section>
          <q-card-section v-if="!persistentLogin">
            <div class="row">
              <div class="col-12">
                <q-btn
                  block
                  color="primary"
                  dark
                  rounded
                  class="full-width"
                  @click="login()"
                >
                  Login
                </q-btn>
              </div>
            </div>
            <div class="row items-center q-my-md">
              <div class="col">
                <div
                  style="width: 100%; min-height: 2px; background: black"
                ></div>
              </div>
              <div style="width: 30px">OR</div>
              <div class="col">
                <div
                  style="width: 100%; min-height: 2px; background: black"
                ></div>
              </div>
              <div class="col-12"></div>
            </div>
            <div class="row">
              <div class="col-12">
                <q-btn
                  block
                  color="accent"
                  dark
                  rounded
                  class="full-width"
                  @click="persistentLogin = true"
                >
                  Ipad Login (SLSNZ Only)
                </q-btn>
              </div>
            </div>
          </q-card-section>
          <q-card-section v-if="persistentLogin">
            <div class="row">
              <div class="col-12 q-my-sm">
                <q-input
                  outlined
                  rounded
                  label="Username"
                  v-model="persistentLoginFormData.username"
                ></q-input>
              </div>
              <div class="col-12 q-my-sm">
                <q-input
                  outlined
                  rounded
                  label="Password"
                  type="password"
                  v-model="persistentLoginFormData.password"
                ></q-input>
              </div>
              <div class="col-6 q-pa-sm q-my-sm">
                <q-btn
                  block
                  color="blue-grey"
                  dark
                  rounded
                  class="full-width"
                  @click="persistentLogin = false"
                >
                  Cancel
                </q-btn>
              </div>
              <div class="col-6 q-pa-sm q-my-sm">
                <q-btn
                  block
                  color="primary"
                  dark
                  rounded
                  class="full-width"
                  :loading="persistentLoginLoading"
                  @click="attemptPersistentLogin()"
                >
                  Login
                </q-btn>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import { auth } from "@/firebase.js";

  export default {
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
      }),
    },
    data: () => ({
      persistentLogin: false,

      persistentLoginLoading: false,

      persistentLoginFormData: {
        username: "",
        password: "",
      },

      backgroundImage: 1,
    }),
    watch: {
      $auth: function () {},
    },
    mounted() {
      let rand = Math.floor(Math.random() * 10 + 1);

      if (rand == 10) {
        rand = 1;
      }
      this.backgroundImage = rand;
    },
    methods: {
      // Log the user in
      login() {
        this.$auth.loginWithRedirect();
      },

      attemptPersistentLogin() {
        this.persistentLoginLoading = true;
        this.$store
          .dispatch("auth/persistentLogin", this.persistentLoginFormData)
          .then((result) => {
            this.persistentLoginLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .loginHeader {
    color: $primary;
    font-weight: 800;
  }
  .slsLogo {
    top: 35px;
    left: 35px;
    width: 250px;
    position: absolute;
  }

  .slsLogoMobile {
    position: relative !important;
    margin: auto !important;
    top: 60px !important;
    left: 0px !important;
  }
</style>

<style>
  .loginCard {
    max-width: 600px;
    width: 90vw;
  }

  .google-signin-button {
    color: white;
    background-color: red;
    height: 50px;
    font-size: 16px;
    border-radius: 10px;
    padding: 10px 20px 25px 20px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
</style>
